
(function () {
    "use strict";

    var BIB_PATTERN = /\bcon dorsal\b|\bwith bib\b/i;
    var BIB_SKU_PATTERN = /-CD$/i; // SKU không bị dịch; chỉ một nửa SP có SKU nên vẫn giữ lọc theo chữ
    var LOG = "[Custom][YMAL] hide bib variants:";

    function isBibVariant(variant) {
        if (variant.sku && BIB_SKU_PATTERN.test(variant.sku)) return true;
        return [variant.title, variant.option1, variant.option2, variant.option3].some(function (value) {
            return value && BIB_PATTERN.test(value);
        });
    }

    function withoutBib(product) {
        try {
            if (!product || !Array.isArray(product.variants)) return product;
            var variants = product.variants.filter(function (variant) { return !isBibVariant(variant); });
            // ponytail: SP chỉ có bản bib thì giữ nguyên, nếu store có loại này thì chuyển sang link PDP
            if (!variants.length || variants.length === product.variants.length) return product;
            return Object.assign({}, product, { variants: variants });
        } catch (error) {
            console.log(LOG, "filter failed, keep product", error);
            return product;
        }
    }

    function patch(Widget) {
        var proto = Widget && Widget.prototype;
        if (!proto || proto.__hideBibVariants) return;
        proto.__hideBibVariants = true;

        var renderEditorialItem = proto.renderEditorialItem;
        if (typeof renderEditorialItem === "function") {
            proto.renderEditorialItem = function (product) {
                return renderEditorialItem.call(this, withoutBib(product));
            };
        }

        var renderUpsellItems = proto.renderUpsellItems;
        if (typeof renderUpsellItems === "function") {
            proto.renderUpsellItems = function () {
                var original = this.upsellItemsData;
                this.upsellItemsData = (original || []).map(withoutBib);
                try {
                    return renderUpsellItems.apply(this, arguments);
                } finally {
                    this.upsellItemsData = original;
                }
            };
        }
    }

    try {
        if (window.customElements) window.customElements.whenDefined("salepify-ymal").then(function () {
            try {
                patch(window.customElements.get("salepify-ymal"));
            } catch (error) {
                console.log(LOG, "patch failed, skip", error);
            }
        });
    } catch (error) {
        console.log(LOG, "install failed, skip", error);
    }

    window.__ymalHideBibVariants = { patch: patch, isBibVariant: isBibVariant };
})();
